import React, { useCallback } from 'react'
import { Grid, Typography } from '@mui/material'
import RocketReachSearchFilters from './components/RocketReachSearchFilters'
import rocketReachSearchColumns from './rocketReachSearchColumns'
import SharedTable from 'pages/Affiliations/components/SharedTable'
import useRocketReachSearch from './hooks/useRocketReachSearch'
import RocketReachDetails from './components/RocketReachDetails'
import { GRID_DETAIL_PANEL_TOGGLE_COL_DEF } from '@the-platform-group/component-library/DataGrid'

const ROCKET_REACH_FILTERING_COLUMNS = ['profilePic', GRID_DETAIL_PANEL_TOGGLE_COL_DEF.field]

const RocketreachSearch = () => {
  const rocketReachHook = useRocketReachSearch() // e.g. { state: {data, total, page, rowsPerPage, isLoading, failed }, setPage, setRowsPerPage, handleSearch }

  const getDetailPanelHeight = useCallback(() => 'auto', [])

  return (
    <Grid container spacing={2} direction="column">
      <Grid item xs={12} sm={6}>
        <Typography variant="h4">Rocketreach Search</Typography>
      </Grid>
      <RocketReachSearchFilters handleSearch={rocketReachHook.handleSearch} />
      <Grid item container xs={12} alignItems="center" sx={{ height: '100%' }}>
        <SharedTable
          rows={rocketReachHook.state.data}
          columns={rocketReachSearchColumns}
          emptyMessage="Search to display contacts."
          useHook={rocketReachHook}
          name="rocketReachSearchTable"
          sx={{}}
          slotProps={{
            columnsPanel: {
              getTogglableColumns: columns =>
                columns.reduce((acc, column) => {
                  if (!ROCKET_REACH_FILTERING_COLUMNS.includes(column.field)) {
                    acc.push(column.field)
                  }
                  return acc
                }, []),
            },
          }}
          getDetailPanelContent={({ row }) => <RocketReachDetails row={row} />}
          getDetailPanelHeight={getDetailPanelHeight}
        />
      </Grid>
    </Grid>
  )
}

export default RocketreachSearch
